import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../../../Base/Components/BaseModal/BaseModal';
import ManagerHookUpCSSZ from './ManagerHookUpCSSZ';

interface Props extends BaseModalProps {
	onSave: () => void;
}

const ManagerHookUpCSSZModal: React.FC<Props> = props => {
	return (
		<BaseModal {...props} title='component.hookUp.cssz.connection'>
			<ManagerHookUpCSSZ onSave={props.onSave} />
		</BaseModal>
	);
};

export default ManagerHookUpCSSZModal;
